var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.me && _vm.me.id === _vm.id)?_c('v-btn',{staticClass:"primary accent-4 white--text mr-2 my-1",attrs:{"to":"/passwordChange","small":""}},[_vm._v("\n  "+_vm._s(_vm.$t("profile.assignment.changePassword"))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }